<script lang="ts">
  import { t } from '$core/i18n';
  import { Modal } from '$ui/primitives/Modal';
  import { Button } from '$ui/primitives/Button';

  let {
    startedAt,
    onResume,
    onDiscard
  }: {
    startedAt: string;
    onResume: () => void;
    onDiscard: () => void;
  } = $props();

  let relative = $derived(formatRelative(startedAt));

  function formatRelative(iso: string): string {
    const then = new Date(iso).getTime();
    if (Number.isNaN(then)) return '';
    const diffMs = Date.now() - then;
    const minutes = Math.floor(diffMs / 60000);
    if (minutes < 1) return t('orphan.justNow');
    if (minutes < 60) return t('orphan.minutesAgo', { n: String(minutes) });
    const hours = Math.floor(minutes / 60);
    if (hours < 24) return t('orphan.hoursAgo', { n: String(hours) });
    const days = Math.floor(hours / 24);
    return t('orphan.daysAgo', { n: String(days) });
  }

  let open = $state(true);
</script>

<Modal
  bind:open
  title={t('orphan.title')}
  size="sm"
  dismissible={false}
  onclose={onDiscard}
>
  <p class="body">{t('orphan.body', { when: relative })}</p>

  {#snippet footer()}
    <Button variant="outline" onclick={onDiscard}>
      {t('orphan.discard')}
    </Button>
    <Button variant="filled" onclick={onResume}>
      {t('orphan.resume')}
    </Button>
  {/snippet}
</Modal>

<style>
  .body {
    margin: 0;
    color: var(--color-text-secondary);
    font-size: var(--text-body);
    line-height: var(--text-body-lh);
    text-wrap: pretty;
  }
</style>